import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";
import axios from 'axios';

// Função para exibir Toast
const showToastify = (message) => {
  Toastify({
    text: message,
    duration: 4000,
    gravity: "top",
    position: "center",
    close: true,
    style: {
      background: "#AEFF00", 
      color: "black",
      borderRadius: "999px",
      padding: "12px 24px",
      fontFamily: "inherit",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
    },
    className: "toastify-custom",
  }).showToast();
};


const form = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const btnNext = document.getElementById('next-step');
    const step1 = document.getElementById('step-1');
    const step2 = document.getElementById('step-2');
    const telefoneInput = document.getElementById('telefone');
    const formElement = document.getElementById('enter-in-contact');

    const lineProgress = document.querySelector('.line-green-contact')
    const stepActive = document.querySelector('.number-step-disable')

    if (!formElement) return;

    // Máscara para telefone (formato: (99) 9 9999-9999)
    telefoneInput?.addEventListener('input', function (e) {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length > 0) {
        value = '(' + value;
      }
      if (value.length > 3) {
        value = value.slice(0, 3) + ') ' + value.slice(3);
      }
      if (value.length > 10) {
        value = value.slice(0, 10) + '-' + value.slice(10, 14);
      }
      if (value.length > 16) {
        value = value.slice(0, 16); // Limita o tamanho máximo
      }
      e.target.value = value;
    });

    // Etapa 1 → Etapa 2
    btnNext?.addEventListener('click', () => {
      const nome = document.getElementById('nome')?.value.trim();
      const email = document.getElementById('email')?.value.trim();
      const telefone = telefoneInput?.value.trim();
      
      if (!nome || !email || !telefone) {
        showToastify("Preencha todos os campos antes de continuar.");
        return;
      }

      //const telefoneValido = /^\(\d{2}\)\s\d\s\d{4}-\d{4}$/.test(telefone);
      const telefoneValido = /^\(\d{2}\)\s*\d\s*\d{4}-\d{4}$/.test(telefone);

      const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!telefoneValido) {
        showToastify("Telefone inválido. Use o formato (99) 9 9999-9999.");
        return;
      }

      if (!emailValido) {
        showToastify("E-mail inválido.");
        return;
      }

      step1?.classList.add('hidden');
      step2?.classList.remove('hidden');
      lineProgress?.classList.remove('w-[50%]')
      lineProgress?.classList.add('w-full')
      stepActive?.classList.remove('number-step-disable')
      stepActive?.classList.add('number-step-active')
    });

    // Submissão final
    formElement?.addEventListener("submit", (e) => {
      e.preventDefault(); // Evita envio padrão

      const mensagem = document.getElementById('mensagem')?.value.trim();
      const confirmacao = document.getElementById('politica')?.checked;

      if (!mensagem || !confirmacao) {
        showToastify("Por favor, escreva sua mensagem e confirme a política de privacidade.");
        return;
      }

      const form_data = {
        nome: document.getElementById('nome')?.value,
        email: document.getElementById('email')?.value,
        telefone: telefoneInput?.value,
        cidade: document.getElementById('cidade')?.value,
        estado: document.getElementById('estado')?.value,
        mensagem: mensagem,
      };

      const btnSubmit = formElement.querySelector("button[type=submit]");
      if (btnSubmit) disabledBtn(btnSubmit);

      axios.post("/fale-conosco/", form_data)
        .then(response => showMessage(response))
        .catch(error => showMessage(error));

      function showMessage(response) {
        const message = response.data?.message || response.message || "Erro ao enviar.";
        showToastify(message);
        formElement.reset();
        step1?.classList.remove('hidden');
        step2?.classList.add('hidden');
        if (btnSubmit) setTimeout(() => enabledBtn(btnSubmit), 1000);
      }

      function disabledBtn(btn) {
        btn.disabled = true;
        btn.classList.add("disabled");
      }

      function enabledBtn(btn) {
        btn.disabled = false;
        btn.classList.remove("disabled");
        lineProgress?.classList.remove('w-full')
        lineProgress?.classList.add('w-[50%]')
        stepActive?.classList.remove('number-step-active')
        stepActive?.classList.add('number-step-disable')
      }
    });
  });
};

export default form;
